import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { OauthBffAuthenticationService } from './oauth-bff-authentication.service';

@Injectable()
export class OAuth2AuthGuard {
    private oAuthBffAuthenticationService = inject(OauthBffAuthenticationService);
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);


    async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {

        if (_state.url === '/?error=true') { // SessionInterceptor error navigation
            return true;
        }

        try {
            let code = route.queryParamMap.get('code');

            // Fallback if angular useHash is true and code is in the hash fragment instead of query params
            if (!code) {
                const urlParams = new URLSearchParams(window.location.search);
                code = urlParams.get('code');
            }

            if (code) {
                await this.oAuthBffAuthenticationService.requestSession(code);
            }
        } catch (error) {
            console.error('ERR', error);
            return false;
        }

        if (this.authenticationService.user && this.authenticationService.containsValidRoleForThisApplication()) {
            return this.router.createUrlTree([
                '/dashboard',
            ]);
        }

        return true;
    }

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.canActivate(route, state);
    }

}
